import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { Button, Form } from "@dpdgroupuk/mydpd-ui";
import PropTypes from "prop-types";
import clsx from "clsx";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { withTrackProps } from "@dpdgroupuk/react-event-tracker";
import { compose } from "recompose";
import { FORM, ANALYTICS } from "../../../../constants";
import FormError from "../../../../components/FormError";
import styles from "./CurrentDetailsForm.module.scss";

const CurrentDetailsForm = ({
  error,
  handleSubmit,
  pristine,
  submitting,
  enabled,
  onCancel,
  previousUsername,
  previousPassword,
  username,
  password,
  onContinue,
  onInputChange,
  onPasswordToggle
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
  className: styles.header
}, "Enter your current details"), /*#__PURE__*/React.createElement("form", {
  onSubmit: handleSubmit
}, /*#__PURE__*/React.createElement(Field, {
  name: "username",
  id: "usernameField",
  type: "text",
  placeholder: "USERNAME",
  autoComplete: "username",
  label: "Username",
  component: Form.MaterialTextInput,
  maxLength: 100,
  disabled: !isEmpty(previousUsername) || !enabled
}), /*#__PURE__*/React.createElement(Field, {
  name: "password",
  id: "passwordField",
  type: "password",
  placeholder: "PASSWORD",
  autoComplete: "password",
  label: "Password",
  component: Form.MaterialTextInput,
  maxLength: 100,
  disabled: !isEmpty(previousPassword) || !enabled,
  onChange: onInputChange,
  onPasswordVisibilityToggle: onPasswordToggle
}), /*#__PURE__*/React.createElement("div", {
  className: clsx(styles.buttons, {
    [styles.hidden]: !enabled
  })
}, /*#__PURE__*/React.createElement(Button, {
  id: "cancelBtn",
  onClick: onCancel,
  variant: "dark",
  className: styles.button
}, "Cancel"), /*#__PURE__*/React.createElement(Button, {
  id: "submitBtn",
  type: "submit",
  variant: "primary",
  disabled: pristine && (isEmpty(username) || isEmpty(password)) || submitting || isEmpty(username) || isEmpty(password),
  className: styles.button,
  onClick: onContinue
}, "Continue"))), enabled && /*#__PURE__*/React.createElement("div", {
  className: styles.error
}, /*#__PURE__*/React.createElement(FormError, {
  errorMessage: error
})));

CurrentDetailsForm.propTypes = {
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  enabled: PropTypes.bool,
  onCancel: PropTypes.func,
  previousUsername: PropTypes.string,
  previousPassword: PropTypes.string,
  username: PropTypes.string,
  password: PropTypes.string,
  onContinue: PropTypes.func,
  onInputChange: PropTypes.func,
  onPasswordToggle: PropTypes.func
};
const selector = formValueSelector(FORM.UPDATE_PASSWORD_FORM);
export default compose(connect((state, props) => {
  const username = selector(state, "username");
  const password = selector(state, "password");
  return {
    initialValues: {
      username: props.previousUsername,
      password: props.previousPassword
    },
    username,
    password
  };
}), reduxForm({
  form: FORM.UPDATE_PASSWORD_FORM
}), withTrackProps({
  onCancel: ANALYTICS.UPDATE_PASSWORD_PAGE.ON_CANCEL,
  onContinue: ANALYTICS.UPDATE_PASSWORD_PAGE.ON_CONTINUE,
  onInputChange: (e, prevValues, nextValues, name) => ANALYTICS.UPDATE_PASSWORD_PAGE.ON_INPUT_CHANGE[name],
  onPasswordToggle: ANALYTICS.UPDATE_PASSWORD_PAGE.ON_PASSWORD_TOGGLE
}))(CurrentDetailsForm);